import { IForm } from '@/react/view-models/Form';
import { Nullable } from '@/type-utils';
import { createContext } from 'react';

/**
 * The context object that contains a form model of some other type and
 * a submit callback.
 */
export interface IFormContext {
  /**
   * The form model associated with this form components. It gets passed
   * into the context and shouldn't ever be set again.
   */
  form: IForm;
  /** The form is currently busy processing. */
  isLoading: boolean;
}

export const FormContext = createContext<Nullable<IFormContext>>(null);
FormContext.displayName = 'FormContext';
